import toast from 'react-hot-toast';

// Mật khẩu chỉ được trả về một lần lúc tạo, nên hiện lâu và cho copy để admin chuyển cho người dùng.
export const notifyAccountCreated = (message: string, user?: { plain_password?: string } | null) => {
  const password = user?.plain_password;
  if (!password) {
    toast.success(message);
    return;
  }

  toast.success(
    <div className="flex flex-col space-y-2">
      <div className="font-medium">{message}</div>
      <div className="text-sm">
        <strong>Mật khẩu:</strong> {password}
      </div>
      <button
        type="button"
        onClick={() => navigator.clipboard.writeText(password)}
        className="text-xs bg-blue-100 hover:bg-blue-200 px-2 py-1 rounded transition-colors"
      >
        Copy mật khẩu
      </button>
    </div>,
    { duration: 10000 }
  );
};
